export default "__VITE_ASSET__GJk4JjIU__"